import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from './Trust.module.scss';

gsap.registerPlugin(ScrollTrigger);

interface StatItemProps {
  end: number;
  suffix?: string;
  label: string;
}

const StatItem: React.FC<StatItemProps> = ({ end, suffix = '', label }) => {
  const numberRef = useRef<HTMLHeadingElement>(null);
  
  useEffect(() => {
    if (!numberRef.current) return;
    
    const ctx = gsap.context(() => {
      // We use an object to tween its property
      const target = { val: 0 };
      
      gsap.to(target, {
        val: end,
        duration: 2.5,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: numberRef.current,
          start: 'top 90%',
          toggleActions: 'play none none reverse'
        },
        onUpdate: () => {
          if (numberRef.current) {
            numberRef.current.innerText = `${Math.floor(target.val)}${suffix}`;
          }
        }
      });
    });
    
    return () => ctx.revert();
  }, [end, suffix]);
  
  return (
    <div className={styles.statItem}>
      <h3 className={styles.statNumber} ref={numberRef}>
        0{suffix}
      </h3>
      <p className={styles.statLabel}>{label}</p>
    </div>
  );
};

const Trust: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      if (containerRef.current) {
        gsap.from(containerRef.current, {
          opacity: 0,
          y: 30,
          duration: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: containerRef.current,
            start: 'top 85%'
          }
        });
      }
    });
    return () => ctx.revert();
  }, []);

  return (
    <section className={styles.trustSection} id="trust">
      <div ref={containerRef} className={styles.container}>
        <StatItem end={8} suffix="+" label="Years Experience" />
        <div className={styles.divider}></div>
        <StatItem end={10} suffix="K+" label="Keywords Ranked" />
        <div className={styles.divider}></div>
        <StatItem end={50} suffix="+" label="Businesses Helped" />
        <div className={styles.divider}></div>
        <StatItem end={98} suffix="%" label="Client Retention" />
      </div>
    </section>
  );
};

export default Trust;
